module.exports = __webpack_public_path__ + "e0a319707738ce244d1c52707119178a.png";